<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table
        :headers="filteredHeaders"
        :items="group.items"
        class="elevation-1"
        item-key="id"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <template v-for="header in headers">
                <td
                  :class="header.align"
                  v-if="showColumn(header.name)"
                  :key="item.id + header.name"
                >
                  <template v-if="header.type == 'checkbox'">
                    <v-checkbox
                      class="align-center justify-center ma-0"
                      v-model="item[header.value]"
                      hide-details
                      :disabled="true"
                    ></v-checkbox>
                  </template>
                  <template v-else-if="header.type == 'actions'">
                    <default-list-actions
                      :item="item"
                      :hideView="true"
                      @deleteItem="deleteItem($event)"
                      @editItem="editItem($event)"
                      :hide-remove="hideDelete"
                    ></default-list-actions>
                  </template>
                  <template v-else>{{ displayValue(item, header) }}</template>
                </td>
              </template>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import DefaultListActions from "./../../shared/DefaultListActions";

export default {
  name: "SimpleDataTableGroup",

  components: {
    DefaultListActions,
  },

  props: {
    group: {
      type: Object,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => [],
    },
    visibleColumns: {
      type: Array,
      default: () => [],
    },
    hideDelete: {
      type: Boolean,
      default: () => false,
    },
  },

  computed: {
    filteredHeaders() {
      return this.headers.filter(
        (h) => this.visibleColumns.indexOf(h.name) > -1
      );
    },
  },
  methods: {
    displayValue(item, header) {
      const value = item[header.value];
      return header.type === "date"
        ? this.$options.filters.formatDate(value)
        : value;
    },
    deleteItem(item) {
      this.$emit("onDeleteItem", { ...item });
    },
    editItem(item) {
      this.$emit("onEditItem", { ...item });
    },
    showColumn(fieldName) {
      return this.visibleColumns.find((name) => name === fieldName);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/extras/SimpleDataTableGroup.vue